import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react'
import './App.css';
import * as THREE from 'three';
import { Stats, Html, Center, OrbitControls, MeshDistortMaterial } from '@react-three/drei';
import { Canvas, extend, useThree, useFrame } from '@react-three/fiber'
import { useLoader } from '@react-three/fiber'
import { useTexture } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import Boxes  from './Boxes.js';

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { TextureLoader } from 'three/src/loaders/TextureLoader.js';
import { MeshBasicMaterial } from 'three';
import { MeshStandardMaterial } from 'three';
import { Vector3 } from 'three';

extend({ EffectComposer, RenderPass, UnrealBloomPass });


function Effect({ down }) {
  const composer = useRef()
  const { scene, gl, size, camera } = useThree()
  const aspect = useMemo(() => new THREE.Vector2(size.width, size.height), [size])
  useEffect(() => void composer.current.setSize(size.width, size.height), [size])
  useFrame(() => composer.current.render(), 1)
  return (
    <>
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      <unrealBloomPass attachArray="passes" args={[aspect, 2, 0.5, 0]} />
    </effectComposer>
    </>
  )
}



const params = new URLSearchParams(window.location.search);
const viewer = params.get('viewer');
let viewerIsOwner = false;
let objkt = parseInt(params.get("objkt"), 10);

const query = `
query Objkt($id: bigint!) {
  hic_et_nunc_token_by_pk(id: $id) {
    token_holders(where: {quantity: {_gt: "0"}}, order_by: {id: asc}) {
      quantity
      holder {
        address
        name
      }
    }
  }
}
`;


async function fetchGraphQL(operationsDoc, operationName, variables) {
  const result = await fetch(
    "https://api.hicdex.com/v1/graphql",
    {
      method: "POST",
      body: JSON.stringify({
        query: operationsDoc,
        variables: variables,
        operationName: operationName
      })
    }
  );

  return await result.json();
}

async function doFetch() {
  if(!objkt) return;
  const { errors, data } = await fetchGraphQL(query, "Objkt", {"id":objkt});
  if (errors) {
    console.error(errors);
  }
  else 
  {
    const result = data.hic_et_nunc_token_by_pk;
    console.log({ result });
    return result;
  }
}

function checkViewerIsOwner(data) {
  if(!data || !data.token_holders) return;
  if (data.token_holders.some((e) => e.holder.address === viewer)) {
    console.log(`viewer IS owner`);
    viewerIsOwner = true;
  } else {
    console.log(`viewer is NOT owner`);
  }
  //console.log({ OBJKT: data });
}

function changeData(data, id) {
  let characters = [];
  console.log("Refreshing");
  if(!data || !data.token_holders) return;
  curData = curData.concat(data.token_holders.map((holder) => { return holder.holder.name ? holder.holder.name : 
    holder.holder.address.substr(0,4) + "..." + holder.holder.address.substr(-4);}));
  for (let i = curData.length - 1; i > data.length * id; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [curData[i], curData[j]] = [curData[j], curData[i]];
  }
  
  for(let i=0; i < curData.length; i++)
  {
    characters.push([(i % 8) * 2 - 7.5 + Math.random(), 18]);
  }
  
  console.log(curData)
  return characters;
}

// let data = doFetch();

let models = [], count = 0, curData=[];
for(let i=0; i < 10; i++)
{
  for(let j=0; j < 9; j++)
  {
    models[count++] = [i, j];
  }
}

function RecursiveBox({size, pos, depth}) {
  console.log(size[0]*size[1]*size[2])
  if(depth > 5) 
    return (
    <mesh position={pos}>
      <boxGeometry args={size} />
      <meshBasicMaterial color={'hsl(' + Math.random()*345 + ', 100%, 50%)'} />
    </mesh>
  );

  let lSize = [size[0] * Math.random(), size[1], size[2]];
  let rSize = [size[0] - lSize[0], size[1], size[2]];

  let lPos = [pos[0] - size[0]/2 + lSize[0] / 2,  pos[1], pos[2]];
  let rPos = [pos[0] + size[0]/2 - rSize[0] / 2,  pos[1], pos[2]];
  console.log(lSize, lPos)
  return <>
    <RecursiveBox size={lSize} pos={lPos} depth={depth+1}/>
    <RecursiveBox size={rSize} pos={rPos} depth={depth+1}/>
  </>
}

function Sphere({pos}) {
  return <mesh position={pos}>
           <sphereGeometry args={[1,16,16]} />
           <meshStandardMaterial color={'purple'}/>
         </mesh>
}

function Organism() {
  const ref = useRef();
  const {scene} = useThree();
  let paths = []
  useEffect(() => {
    // let indices = ref.current.geometry.index.array;

    let randObj1 = Math.floor(Math.random() * ref.current.children.length);
    let randObj2 = Math.floor(Math.random() * ref.current.children.length);

    let object1 = randObj1 === 0 || Math.random() < 0.3 ? ref.current : ref.current.children[randObj1];
    let object2 = randObj2 === 0 || Math.random() < 0.3 ? ref.current : ref.current.children[randObj2];

    let geometry = object1.geometry.attributes.position.array;

    let rand1 = Math.floor(Math.random() * geometry.length / 3) * 3;
    let randPoint1 = new THREE.Vector3(geometry[rand1], geometry[rand1+1], geometry[rand1+2]);

    geometry = object2.geometry.attributes.position.array;
    let rand2 = Math.floor(Math.random() * geometry.length / 3) * 3;
    let randPoint2 = new THREE.Vector3(geometry[rand2], geometry[rand2+1], geometry[rand2+2]);


    let midPoint = randPoint1.clone().add(randPoint2);
    
    let curve = new THREE.CatmullRomCurve3([randPoint1, midPoint, randPoint2]);
    paths.push(curve);
    let tubeGeometry = new THREE.TubeGeometry( curve, 10, 0.01, 3, false );

    let sphere = new THREE.Mesh(tubeGeometry, new THREE.MeshStandardMaterial({color: 'grey'}));
    // sphere.position.copy(randPoint1);
    ref.current.add(sphere)
    console.log(ref.current.children.length)
    // console.log(ref.current);
  })

  useFrame(({clock}) => {
    for(let child of ref.current.children) {
      let curve = child.geometry.parameters.path;
      curve.points[1] = new THREE.Vector3(Math.sin(clock.getElapsedTime())*2, Math.cos(clock.getElapsedTime())*2, curve.points[1].z);
      child.geometry = new THREE.TubeGeometry( curve, 10, 0.01, 3, false );
    }
    // console.log(ref.current.children[0].geometry.parameters.path)
  })

  return (
    <>
    <mesh ref={ref}>
      <sphereGeometry args={[1,16,16]} />
      <meshStandardMaterial color={'grey'} />
      {/* <MeshDistortMaterial distort={0.5} speed={1}/> */}
    </mesh>
    </>
  )
}


function App() {
  const [id, setId] = useState(0);
  const [characters, set] = useState([]);

  useEffect(() => {
    // doFetch(objkt)
    //   .then((data) => changeData(data, id))
    //   .then((char) => set(char));
  }, [id])


  return (
    <div id="wrapper" onMouseDown={() => {console.log("PRESSED")}}>
  <Canvas>
    <Effect />
      <ambientLight intensity = {0.1} />
      <pointLight position={[0,0,0]} intensity={3.0} color={'yellow'}/>
      {/* <RecursiveBox pos={[0,0,0]} size={[10,10,10]} depth={0}/> */}
      {/* <Organism /> */}
      <Boxes amount={1000} wireframe={true}/>
    <OrbitControls panSpeed={0}/> 
    {/* <Stats /> */}
  </Canvas>
  </div>
  );
}

export default App;
